import { zSchema } from "../../../schema-validation";

export const migrateStateAgencySchema = zSchema.object({
  code: zSchema.string(),
  account_number: zSchema.string(),
  routing_number: zSchema.string(),
  account_type: zSchema.string(),
  overwrite_existing: zSchema.boolean().optional(),
});
